import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { Store } from "../../../ducks/store";
import { useStore } from "../../../hooks/useStore";
import { FavoriteStoreItem } from "../../molecules/store/FavoriteStoreItem";

export const FavoriteStoreList: React.FC = () => {
  const { favoriteStores, setFavoriteStore } = useStore([]);

  const [favoriteStoresToShow, setFavoriteStoresToShow] = useState<
    Store[] | null
  >(null);

  useEffect(() => {
    if (!favoriteStores) return;

    if (!favoriteStoresToShow) {
      setFavoriteStoresToShow(favoriteStores);
      return;
    }

    const favoriteStoreIds = favoriteStores.map((store) => store.id);

    const newFavoriteStoresToShow = favoriteStoresToShow.map((store) => ({
      ...store,
      isFavorite: favoriteStoreIds.includes(store.id),
    }));

    setFavoriteStoresToShow(newFavoriteStoresToShow);
  }, [favoriteStores]);

  const handleClosePopup = useCallback(() => {
    setFavoriteStoresToShow(
      (prev) => prev?.filter((store) => store.isFavorite) ?? [],
    );
  }, []);

  if (!favoriteStoresToShow || favoriteStoresToShow.length === 0) return null;

  return (
    <>
      <TitleWrapper>マイ店舗</TitleWrapper>

      {favoriteStoresToShow.map((store) => (
        <FavoriteStoreItem
          key={store.id}
          name={store.name}
          address={store.prefecture + store.city + store.address}
          phoneNumber={store.phoneNumber}
          service={store.service}
          location={{
            lat: store.location.latitude,
            lng: store.location.longitude,
          }}
          isFavorite={store.isFavorite}
          onFavorite={(favorite) => setFavoriteStore(store.id, favorite)}
          onDelete={() => {
            setFavoriteStore(store.id, false);
            setFavoriteStoresToShow(
              favoriteStoresToShow.filter((s) => s.id !== store.id),
            );
          }}
          onClosePopup={handleClosePopup}
        />
      ))}
    </>
  );
};

const TitleWrapper = styled.div`
  color: ${BASIC_DARK_GRAY};
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  line-height: 1em;
  margin: 0 0 16px 0;
`;
